import { Box } from '@mui/material';
import { AuthButton } from './AuthButton';
import css from './AuthConsumeStatus.module.scss';
import { AuthErrorMessage } from './AuthErrorMessage';

interface AuthConsumeStatusProps {
  /** When set, the error + retry CTA is shown instead of the loading line. */
  error: string | null;
  /** Transient message shown while the code is being consumed. */
  loadingText: string;
  /** Label for the retry button shown on error. */
  retryLabel: string;
  /** Invoked when the user clicks the retry button. */
  onRetry: () => void;
}

/**
 * Shared loading / error surface for the mount-time code-consumer pages
 * (magic-link and confirm-email). Pairs with `useConsumeCode`.
 */
export function AuthConsumeStatus({
  error,
  loadingText,
  retryLabel,
  onRetry,
}: AuthConsumeStatusProps) {
  if (error) {
    return (
      <Box className={css.container}>
        <AuthErrorMessage message={error} />
        <AuthButton type="button" onClick={onRetry}>
          {retryLabel}
        </AuthButton>
      </Box>
    );
  }

  return (
    <Box className={css.container}>
      <span className={css.loading}>{loadingText}</span>
    </Box>
  );
}
